import axios from "axios";
import { APIRequestURI } from "../../utils/api_request_uri";
import {
  GET_PRICING_OPTIONS_FAILED,
  GET_PRICING_OPTIONS_REQUEST,
  GET_PRICING_OPTIONS_SUCCESS,
} from "../../constants/Pricing/pricingConstants";

export const getPricingOptionsAction =
  ({ eligibleItems, country }) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PRICING_OPTIONS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Normalize items here
      const formattedItems = eligibleItems.map((item) => ({
        itemType: item.itemType,
        itemId: item.itemId || null,
      }));

      const payload = {
        eligibleItems: formattedItems,
        country,
      };

      const URI = new APIRequestURI().getBaseURI();

      const { data } = await axios.post(
        `${URI}/api/pricing/options`,
        payload,
        config
      );

      dispatch({
        type: GET_PRICING_OPTIONS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PRICING_OPTIONS_FAILED,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
